import React,{Component} from 'react'
import Link from 'react-router'
import {language} from 'UTIL/common'
const returnJson =(map) =>{
    const json = [];
    for(var key in map)
    {
        const arr = {"id":key,"name":map[key]};
        json.push(arr);
    }
    const data = json.map(function (str,index) {
        return <option value={str.id} key={index}>{str.name}</option>
    });
    return data;
};
export default class SearchSelect extends Component{
    constructor(props){
        super(props);
    }
     render(){
        const options = returnJson(this.props.data);
        return (
                <div className="form-group clearfix fl">

                    <label className="control-name">{this.props.name}</label>
                    <select className="form-control" id={this.props.id} >
                        <option value=''>请选择</option>
                        {options}
                    </select>
                </div>
        )
     }
}
//下拉框搜索
//<SearchSelect id="" name="" data="" />传入的data值是map类型


// WEBPACK FOOTER //
// ./modules/component/search/searchSelect.js